import moment from "moment";
import Vue from 'vue';
import { router } from '@/router';
import _ from 'lodash';
import store from '@/store';

function initialState() {
    return {
        chartloaded: false,
        labels: [],
        datasets: [
            // Sample Object
            //     {
            //     label: '',
            //     backgroundColor: '#f87979',
            //     data: []
            // }
        ],
        FnB_labels: [], //Fnb Items Labels && FnB Category Labels Time-Series Chart
        FnB_datasets: [], //Fnb Items Datasets Time-Series Chart
        FnB_Items_Pielabels: [], //Fnb Items Labels Pie Chart
        FnB_Items_Piedatasets: [], //Fnb Items Datasets Pie Chart

        FnB_Category_datasets: [], //FnB Category Datasets Time-Series Chart
        FnB_Category_Pielabels: [], //FnB Category Labels Pie Chart
        FnB_Category_Piedatasets: [], //FnB Category Datasets Pie Chart

        Movie_labels: [],
        Movie_datasets: [],
        Get_five_Movies: [],
        Moviechartloaded: false,
        FnBchartloaded: false,

        chartOptions: {
            responsive: true,
            maintainAspectRatio: false
        }
    }
}

const state = initialState();

const mutations = {
    SET_CHART_DATA: (state, payload) => {
        state.labels = [];
        state.datasets = [];
        payload.map(x => {
            state.labels.push(moment(x.t_show_date).format('YYYY-MM-DD'))
        })
        payload.map(showDates => {
            state.datasets.push(showDates.transactions.reduce((acc, { total_tickets_sold }) => acc + (total_tickets_sold), 0).toFixed(3))
        })
        // console.log('state.labels :', state.labels);
        // console.log('state.datasets :', state.datasets);
        state.chartloaded = true;
    },
    SET_FNB_CHART_DATA: (state, payload) => {
        state.FnB_labels = [];
        state.FnB_datasets = [];

        state.FnB_Items_labels = [];
        state.FnB_Items_Piedatasets = [];

        state.FnB_Category_datasets = [];

        state.FnB_Category_Pielabels = []
        state.FnB_Category_Piedatasets = []

        state.FnB_labels = getDates(payload.Dates.fromDate, payload.Dates.endDate)

        //Getting Date Range
        function getDates(startDate, stopDate) {
            var dateArray = [];
            var currentDate = moment(startDate);
            var stopDate = moment(stopDate);
            while (currentDate <= stopDate) {
                dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
                currentDate = moment(currentDate).add(1, 'days');
            }
            return dateArray;
        }

        state.FnB_labels = state.FnB_labels.slice().sort((a, b) => moment(a).valueOf() - moment(b).valueOf());

        // borderColor: '#' + Math.floor(Math.random() * 16777215).toString(16), //Previous Working
        payload.data2.map(x => {
            state.FnB_datasets.push({
                type: 'line',
                label: x.Data[0].fst_item_name,
                borderColor: dynamicColors(),
                fill: false,
                date: x.Data.map(z => { return { date: moment(z.Date).format('YYYY-MM-DD'), total_sold: z.total_sold } }), //Just For Filtering purpose
                data: x.Data.map((y) => y.total_sold)
                // data:
                // x.Data.map((y) => {
                //     payload.data1.map(z => {
                //         console.log('z.Date :', z.Date);
                //         console.log('z.Date == y.Date :', z.Date == y.Date);
                //         if (z.Date == y.Date) {
                //             console.log('y.total_sold :', y.total_sold);

                //             return y.total_sold
                //         }
                //         else {
                //             return 0
                //         }
                //         // return z.Date == y.Date ? y.total_sold : 0
                //     })
                // })


            })
        })
        payload.CategoryData.map(x=>{
            state.FnB_Category_datasets.push({
                type: 'line',
                label: x.Data[0].fc_category,
                borderColor: dynamicColors(),
                fill: false,
                date: x.Data.map(z => { return { date: moment(z.Date).format('YYYY-MM-DD'), total_sold: z.total_sold } }), //Just For Filtering purpose
                data: x.Data.map((y) => y.total_sold)
            })
        })

        state.FnB_labels.map(x => {
            state.FnB_datasets.map(y => {
                let index = y.date.findIndex(z => {
                    return x == z['date'];
                });

                if (index < 0) {
                    y.date.push({ date: x, total_sold: 0 })
                }
            })

            state.FnB_Category_datasets.map(y => {
                let index = y.date.findIndex(z => {
                    return x == z['date'];
                });

                if (index < 0) {
                    y.date.push({ date: x, total_sold: 0 })
                }
            })
        })

        state.FnB_datasets = state.FnB_datasets.map(x => {
            x.date = x.date.slice().sort((a, b) => { return moment(a['date']).valueOf() - moment(b['date']).valueOf() })

            x.data = x.date.map(r => {
                return x.data = r['total_sold']
            })
            return x;
        })

        state.FnB_Category_datasets = state.FnB_Category_datasets.map(x => {
            x.date = x.date.slice().sort((a, b) => { return moment(a['date']).valueOf() - moment(b['date']).valueOf() })

            x.data = x.date.map(r => {
                return x.data = r['total_sold']
            })
            return x;
        })

        state.FnB_datasets.map(x => {
            let total_sum_sold = x.data.reduce(function (ac, y) { return ac += y }, 0)
            state.FnB_Items_labels.push(x.label);

            if (state.FnB_Items_Piedatasets.length == 0) {
                state.FnB_Items_Piedatasets.push({ label: 'FnB Items Data', backgroundColor: [x.borderColor], data: [total_sum_sold] })
            } else {
                if (state.FnB_Items_Piedatasets.length <= 10) {
                    state.FnB_Items_Piedatasets[0]['data'].push(total_sum_sold)
                    state.FnB_Items_Piedatasets[0]['backgroundColor'].push(x.borderColor)
                }

            }
        })

        state.FnB_Category_datasets.map(x => {
            let total_sum_sold = x.data.reduce(function (ac, y) { return ac += y }, 0)
            state.FnB_Category_Pielabels.push(x.label);

            if (state.FnB_Category_Piedatasets.length == 0) {
                state.FnB_Category_Piedatasets.push({ label: 'FnB Category Data', backgroundColor: [x.borderColor], data: [total_sum_sold] })
            } else {
                if (state.FnB_Category_Piedatasets.length <= 10) {
                    state.FnB_Category_Piedatasets[0]['data'].push(total_sum_sold)
                    state.FnB_Category_Piedatasets[0]['backgroundColor'].push(x.borderColor)
                }

            }
        })

        function dynamicColors() {
            var r = Math.floor(Math.random() * 255);
            var g = Math.floor(Math.random() * 255);
            var b = Math.floor(Math.random() * 255);

            if (r == 255 && g == 255 && b == 255) {
                dynamicColors();
            } else {
                return "rgb(" + r + "," + g + "," + b + ")";
            }
        }

        state.FnBchartloaded = true;
    },
    SET_MOVIE_ANALYTICS_CHART_DATA: (state, payload) => {
        state.Movie_labels = [];
        state.Movie_datasets = [];
        state.Get_five_Movies = [];

        let newarray = [];
        // payload.map(y => {

        //     let findindex = newarray.findIndex(x => {
        //         return moment(x.t_show_date).format('YYYY-MM-DD') === moment(y.t_show_date).format('YYYY-MM-DD');
        //     });

        //     if (findindex >= 0) {
        //         newarray[findindex]["dates"].push(moment(y.t_show_date).format('YYYY-MM-DD'))
        //     } else {
        //         newarray.push({
        //             dates: [moment(y.t_show_date).format('YYYY-MM-DD')],
        //             t_show_date: moment(y.t_show_date).format('YYYY-MM-DD')
        //         });

        //         state.Movie_labels.push(moment(y.t_show_date).format('YYYY-MM-DD'))
        //     }
        // })

        state.Movie_labels = getDates(payload.Dates.fromDate, payload.Dates.endDate)

        //Getting Date Range
        function getDates(startDate, stopDate) {
            var dateArray = [];
            var currentDate = moment(startDate);
            var stopDate = moment(stopDate);
            while (currentDate <= stopDate) {
                dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
                currentDate = moment(currentDate).add(1, 'days');
            }
            return dateArray;
        }

        //Sorting Date
        state.Movie_labels = state.Movie_labels.slice().sort((a, b) => moment(a).valueOf() - moment(b).valueOf());

        //Finding Same md_id and push total_amount into same md_id array 
        payload.Records.map(y => {
            let findindex = state.Movie_datasets.findIndex(x => {
                return x.md_id == y.md_id;
            });

            if (state.Movie_datasets.length <= 5) {
                if (findindex >= 0) {
                    state.Movie_datasets[findindex]["data"].push(y.total_amount)
                    state.Movie_datasets[findindex]["date"].push({
                        date: moment(y.t_show_date).format('YYYY-MM-DD'),
                        amount: y.total_amount
                    })
                } else {
                    state.Movie_datasets.push({
                        type: 'line',
                        label: y.movie_name,
                        borderColor: dynamicColors(),
                        fill: false,
                        date: [{
                            date: moment(y.t_show_date).format('YYYY-MM-DD'),
                            amount: y.total_amount
                        }],
                        data: [y.total_amount],
                        md_id: y.md_id
                    });

                    state.Get_five_Movies.push({
                        md_id: y.md_id,
                        movie: y.movie_name
                    })
                }
            }
        })

        state.Movie_labels.map(x => {
            state.Movie_datasets.map(y => {
                let index = y.date.findIndex(z => {
                    return x == z['date'];
                });

                if (index < 0) {
                    y.date.push({ date: x, amount: 0 })
                }
            })
        })

        state.Movie_datasets = state.Movie_datasets.map(x => {
            x.date = x.date.slice().sort((a, b) => { return moment(a['date']).valueOf() - moment(b['date']).valueOf() })

            x.data = x.date.map(r => {
                return x.data = r['amount']
            })
            return x;
        })

        function dynamicColors() {
            var r = Math.floor(Math.random() * 255);
            var g = Math.floor(Math.random() * 255);
            var b = Math.floor(Math.random() * 255);

            if (r == 255 && g == 255 && b == 255) {
                dynamicColors();
            } else {
                return "rgb(" + r + "," + g + "," + b + ")";
            }
        }

        store.dispatch('setSelectedMovies', state.Get_five_Movies);
        state.Moviechartloaded = true;

    },
    SET_CHART_HIDE: (state, payload) => {
        state.Moviechartloaded = payload
    },
    SET_FETCHED_MOVIES: (state, payload) => {
        state.Get_five_Movies.map((x, index) => {
            if (payload['md_id'] == x['md_id']) {
                state.Get_five_Movies.splice(index, 1);
                store.dispatch('setSelectedMovies', state.Get_five_Movies);
            }
        })

    },
    SET_FnB_CLEAR_Analytics: (state, payload) => {
        state.FnBchartloaded = payload.chartShow
        state.FnB_labels = payload.chartClear
        state.FnB_datasets = payload.chartClear
    }
}

const actions = {
    onSetChartData: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_CHART_DATA', payload);
    },
    onSetMovieAnalytics_ChartData: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_MOVIE_ANALYTICS_CHART_DATA', payload);
    },
    onSetFnbAnalyticsChartData: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_FNB_CHART_DATA', payload);
    },
    HideChart: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_CHART_HIDE', payload);
    },
    onSetRangeOfDate: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_MOVIE_ANALYTICS_CHART_DATA', payload);
    },
    removeUnSelectMovie: async ({ dispatch, commit, state }, payload) => {
        commit('SET_FETCHED_MOVIES', payload)
    },
    FnBHideChart: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_FnB_CLEAR_Analytics', payload);
    }
}

const getters = {
    getChartOptions: state => state.chartOptions,
    chartloaded: state => state.chartloaded,
    getLabels: state => state.labels,
    getdatasets: state => state.datasets,
    getFnbLables: state => state.FnB_labels,
    getFnbdatasets: state => state.FnB_datasets,

    getFnBpiedatasets: state => state.FnB_Items_Piedatasets,
    getFnBpielabels: state => state.FnB_Items_labels,

    getFnBCategoriesdatasets: state => state.FnB_Category_datasets,

    getFnBCategoriesPieLabel: state => state.FnB_Category_Pielabels,
    getFnBCategoriesPieDatasets: state => state.FnB_Category_Piedatasets,

    getMovieLabels: state => state.Movie_labels,
    getMoviedatasets: state => state.Movie_datasets,
    getAllMovies: state => state.All_Movies,
    FnBchartloaded: state => state.FnBchartloaded,
    Moviechartloaded: state => state.Moviechartloaded,
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/ChartStore.js